module.exports = __webpack_public_path__ + "img/default-image.6513bb10.png";